import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import {
    ProvisionCoachAccessInputDto,
    ProvisionCoachAccessOutputDto,
} from "../../../models/coach/dto/provision-coach-access.dto";
import { GET_COACH_QUERY_KEY } from "./useGetCoach";
import { GET_COACHS_QUERY_KEY } from "./useListCoachs";

/**
 * Give an existing coach profile a dashboard login (admin-only). The response
 * may carry a one-time password-setup link (fresh accounts only) — the caller
 * is responsible for showing it to the admin exactly once.
 */
export const useProvisionCoachAccess = (coachId: string, organizationId?: string) => {
    const apiClient = useApiClient();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (input: ProvisionCoachAccessInputDto) =>
            apiClient.fetchApi<ProvisionCoachAccessOutputDto, ProvisionCoachAccessInputDto>({
                method: 'POST',
                endpoint: `coachs/${coachId}/provision-access`,
                body: input,
            }),
        onSuccess: (data) => {
            queryClient.setQueryData(GET_COACH_QUERY_KEY(coachId), data.coach);
            if (organizationId)
                queryClient.invalidateQueries({ queryKey: GET_COACHS_QUERY_KEY(organizationId) });
        },
    });
};
